import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { historyService } from '../../services/historyService';

export const useGetRoundsSummary = () => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.history.rounds_summary],
    queryFn: () =>
      historyService.roundsSummary().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
